import { render, staticRenderFns } from "./firm_data_detail.vue?vue&type=template&id=0ae84596&scoped=true"
import script from "./firm_data_detail.vue?vue&type=script&lang=js"
export * from "./firm_data_detail.vue?vue&type=script&lang=js"
import style0 from "./firm_data_detail.vue?vue&type=style&index=0&id=0ae84596&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae84596",
  null
  
)

export default component.exports